module.exports = __webpack_public_path__ + "static/media/navigation-tools.5062a405.svg";